module.exports = __webpack_public_path__ + "app/modals/raw-report-modal.view.html";